// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/single.scss
// module id = 58
// module chunks = 5